const ExpirationType = {
  DURATION: 1,
  EXPIRY_DATE: 2
}

export default ExpirationType
